import { getImage, getMapScale } from '../utils/map-helpers';

import type { ClickableAreaConfig, DrawFunctionPayload } from '../types/Map';
import type { ObjectThingy } from '../types/test';
import type CustomContext from '../utils/CustomContext';

declare global {
  // eslint-disable-next-line vars-on-top, no-var
  var imageSize: number;
}

export default (
  data: ObjectThingy,
  ctx: CustomContext,
  info: DrawFunctionPayload,
  { addClickArea }: { addClickArea: (a: ClickableAreaConfig) => void },
) => {
  const { Position, StaticId, Type } = data;

  const pos = {
    x: Position.X,
    y: Position.Y,
    z: Position.Z,
  };

  const elementSize = getMapScale(25, info.canvasWidth, info.mapWidth);

  addClickArea({
    startPos: {
      x: pos.x - elementSize / ctx.getMapScale(),
      y: pos.y - elementSize / ctx.getMapScale(),
    },
    endPos: {
      x: pos.x + elementSize / ctx.getMapScale(),
      y: pos.y + elementSize / ctx.getMapScale(),
    },
    callback: () => {
      console.log(StaticId);
    },
    fixed: false,
  });

  const image = getImage(`/images/${Type}.png`);

  if (image instanceof HTMLImageElement && image.hidden) {
    ctx.drawRect({
      position: pos,
      size: {
        x: 11,
        y: 11,
      },
      color: 'black',
    });

    ctx.drawRect({
      position: pos,
      size: {
        x: 9,
        y: 9,
      },
      color: 'white',
    });

    return;
  }

  ctx.drawImage({
    image,
    position: pos,
    size: {
      y: global.imageSize || 40,
      x: global.imageSize || 40,
    },
    fixedSize: true,
  });
};
